
import React from 'react';
import { cn } from '@/lib/utils';
import { Clock } from 'lucide-react';

interface TimelineItemProps {
  step: number;
  title: string;
  description: React.ReactNode;
  timeframe: string;
  isLast?: boolean;
  alignment?: 'left' | 'right';
}

const TimelineItem: React.FC<TimelineItemProps> = ({
  step,
  title,
  description,
  timeframe,
  isLast = false,
  alignment = 'left'
}) => {
  return (
    <div className={cn(
      "flex relative",
      alignment === 'right' && "flex-row-reverse"
    )}>
      {/* Center dot over the timeline */}
      <div className="absolute left-1/2 -translate-x-1/2 w-5 h-5 bg-brand-teal rounded-full z-10 top-6"></div>
      
      <div className={cn("w-1/2 pr-8", alignment === 'right' && "pl-8 pr-0 text-right")}>
        <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow duration-300 relative z-10">
          <div className="flex items-center mb-2">
            <span className="w-6 h-6 flex items-center justify-center bg-brand-teal text-white rounded-full text-sm font-bold mr-2">
              {step}
            </span>
            <h3 className="text-xl font-bold">{title}</h3>
          </div>
          <p className="text-gray-700">{description}</p>
        </div>
      </div>
      
      <div className={cn(
        "w-1/2 pl-8 flex items-center",
        alignment === 'right' && "pr-8 pl-0 justify-end"
      )}>
        <div className="flex items-center text-sm text-brand-teal font-medium">
          <Clock size={14} className="mr-1" />
          <span>{timeframe}</span>
        </div>
      </div>
    </div>
  );
};

export default TimelineItem;
